type ApiErrorPayload = {
  message?: unknown;
};

type ApiErrorLike = {
  response?: {
    data?: ApiErrorPayload;
  };
};

// Architectural summary: Extracts user-facing error messages from Axios-style
// service failures without using `any`, with a deterministic fallback.
export function extractServiceErrorMessage(error: unknown, fallbackMessage: string): string {
  const normalizedFallback = fallbackMessage.trim().length > 0 ? fallbackMessage : 'Request failed';
  const maybeApiError = error as ApiErrorLike;
  const apiMessage = maybeApiError.response?.data?.message;

  if (typeof apiMessage === 'string' && apiMessage.trim().length > 0) {
    return apiMessage;
  }

  if (error instanceof Error && error.message.trim().length > 0) {
    return error.message;
  }

  return normalizedFallback;
}
